// src/components/SideBar/menuConfig.ts
import { ReactComponent as HomeIcon } from "@/assets/sidebar/home.svg?react";
import { ReactComponent as FlowIcon } from "@/assets/sidebar/new-flow.svg?react";
import { ReactComponent as ResultsIcon } from "@/assets/sidebar/results.svg?react";
import { ReactComponent as MypageIcon } from "@/assets/sidebar/my-page.svg?react";
import { ReactComponent as GuideIcon } from "@/assets/sidebar/guide.svg?react";

export type SubMenuItem = {
  id: string;
  label: string;
  route?: string;
  isProductFlow?: boolean; // 제품 플로우 여부 (upload 페이지로 이동)
  disabled?: boolean;
};

export type MenuItem = {
  id: string;
  label: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  ActiveIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  route?: string;
  subMenu?: SubMenuItem[];
};

export const menuItems: MenuItem[] = [
  {
    id: "workspace",
    label: "워크스페이스",
    Icon: HomeIcon,
    route: "workspace",
  },
  {
    id: "flow",
    label: "새 프로젝트",
    Icon: FlowIcon,
    subMenu: [
      {
        id: "upload/audion_vu",
        label: "음성이해",
        route: "upload/audion_vu",
      },
      {
        id: "upload/audion_vh",
        label: "보이스 하이라이트",
        route: "upload/audion_vh",
      },
      // {
      //   id: "upload/audion_sg",
      //   label: "자막 생성",
      //   route: "upload/audion_sg",
      // },
      {
        id: "realtime_stt",
        label: "실시간 음성인식",
        route: "realtime_stt",
      },
    ],
  },
  {
    id: "results",
    label: "결과 관리",
    Icon: ResultsIcon,
    route: "results",
  },
  {
    id: "mypage",
    label: "마이페이지",
    Icon: MypageIcon,
    subMenu: [
      { id: "mypage", label: "프로필 관리", route: "mypage" },
      { id: "billing", label: "결제·구독 관리", route: "billing" },
    ],
  },
  {
    id: "guide",
    label: "개발자 가이드",
    Icon: GuideIcon,
    route: "",
  },
];
